import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { Post } from '@vs-online-only-app/state';
import { UserAvatar } from '@vs-online-only-app/ui';

const PostAuthor: FC<Post['author']> = ({ avatar, name }) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <UserAvatar imageSrc={avatar} variant="rounded" />
    <Typography variant="body2" color="textSecondary">
      {name}
    </Typography>
  </Stack>
);

export default PostAuthor;
